import { BASE_PATH } from '@/consts/environmental';

import { createAgencyApiUrls } from './createApiUrls';
import { createHydrogenUrls } from './createHydrogenUrls';
import { createAgencyLegacyUrls } from './createLegacyUrls';
import { createAgencySiteUrls } from './createSiteUrls';

const appUrl = process.env.NEXT_PUBLIC_AGENCY_APP_URL;
const siteUrl = process.env.NEXT_PUBLIC_AGENCY_SITE_URL;
const hydrogenUrl = process.env.NEXT_PUBLIC_CUROLOGY_HYDROGEN_URL;

export const agencyUrls = {
  base: `${appUrl}${BASE_PATH}`,
  api: createAgencyApiUrls(appUrl),
  legacy: createAgencyLegacyUrls(appUrl),
  site: createAgencySiteUrls(siteUrl),
  hydrogen: createHydrogenUrls(hydrogenUrl),
};
